// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('popover_add_list');

// eslint-disable-next-line @trello/no-module-logic
export const PopoverAddListTemplate = t.renderable(function ({
  tooManyTotalLists,
  tooManyOpenLists,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  if (tooManyTotalLists) {
    t.p(() => t.format('you-have-too-many-lists-on-this-board'));
    return;
  }

  if (tooManyOpenLists) {
    t.p(() => t.format('you-have-too-many-open-lists-on-this-board'));
    return;
  }

  return t.form(function () {
    t.div('.form-grid.add-list-popover', function () {
      t.div('.form-grid-child.form-grid-child-threequarters', function () {
        t.label({ for: 'list-name' }, () => t.format('name'));
        return t.input('.js-list-name.js-autofocus.list-name-text-field', {
          type: 'text',
          id: 'list-name',
          value: t.l('default-list-name'),
          style: 'margin-bottom: 0;',
        });
      });

      return t.div('.form-grid-child', () =>
        t.div(
          '.button-link.setting',
          { style: 'margin-top: 4px; position: relative;' },
          function () {
            t.span('.label', () => t.format('position'));
            t.span('.value.js-pos-value');
            t.label(() => t.format('position'));
            return t.select('.js-select-list-pos');
          },
        ),
      );
    });

    return t.input('.nch-button.nch-button--primary.wide.js-add-list', {
      type: 'submit',
      value: t.l('add'),
    });
  });
});
